// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","services":"services-1aH7x","hidden":"hidden-DfVb4"};